<template>
<div>
  <div class="m_context">
		<el-row :gutter="10" style="margin-bottom: 20px;">
			<el-col :span="4" style="padding-left: 24px;">
		        <el-input
	  			  :placeholder="$t('lin_global.label_no')"
	  			  icon="search"
	  			  v-model="queryCondition.terminal_no"
	  			  :on-icon-click="handleIconClick"
	  			  @keyup.enter.native="focusEvent(handleIconClick)">
	  			</el-input>
	        </el-col>
	        <el-col :span="4">
	        	<!--<el-select v-model="queryCondition.areaid" @change="statusChange" placeholder="">-->
		          <!--<el-option v-for="item in areaList1" :label="item.mechanismname" :value="item.mechanismid"></el-option>-->
		        <!--</el-select>-->
            <MechanismSelector :data="mechanismData"></MechanismSelector>
			    </el-col>
	        <el-col :span="4">
	        <el-date-picker type="date" @change="dataChange" clearable :placeholder="$t('terminal.appLog.start_time')" v-model="queryCondition.start_time" style="width: 100%;"></el-date-picker>
	        </el-col>
	        <el-col :span="4">
	        <el-date-picker type="date" @change="dataChange1" clearable :placeholder="$t('terminal.appLog.end_time')" v-model="queryCondition.end_time" style="width: 100%;"></el-date-picker>
	        </el-col>
	        <el-col :span="2">
	         <el-button type="primary" @click="search" style="width:100%" >{{$t('lin_btn.check')}}</el-button>
	         </el-col>
	          <el-col :span="2">
	         <el-button @click="reset" style="width:100%" >{{$t('lin_btn.reset')}}</el-button>
	         </el-col>
					 <el-col :span="3">
	         	<el-button @click="catchLog" type='primary' style="width:100%" >{{$t('app_catchlog')}}</el-button>
	         </el-col>
	    </el-row>
	<el-table v-loading="loading" :element-loading-text="$t('lin_global.loading')" :data="tableData" id="tableData" border style="width:100%">
      <el-table-column prop="terminalNo" :label="$t('lin_global.label_no')" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="terminalName" :label="$t('lin_global.label_name')" :show-overflow-tooltip="true"></el-table-column>
    <el-table-column prop="mechName" :label="$t('lin_global.label_areaid')" :show-overflow-tooltip="true"></el-table-column>
    <el-table-column prop="beginTime" :label="$t('lin_global.logStartTime')"></el-table-column>
    <el-table-column prop="endTime" :label="$t('lin_global.logEndTime')"></el-table-column>
      <el-table-column prop="status" :label="$t('lin_global.status')" :formatter="formatStatus" :show-overflow-tooltip="true" width="150"></el-table-column>
    <el-table-column
      :label="$t('lin_global.ope')" width="150">
      <template slot-scope="scope">
      
      
			<!-- <a style="color: #4db3ff;margin-left: 10px" v-if="scope.row.down" :href='baseUrl+scope.row.logUrl'>{{$t('lin_global.download')}}</a> -->
			<el-tooltip class="item" effect="dark" :content="$t('lin_global.download')" placement="top">
				<a style="color: #4db3ff;margin-left: 10px" v-if="scope.row.down" :href='baseUrl+scope.row.logUrl'><i class="fa fa-cloud-download" style=""></i></a>
			</el-tooltip>

			<!-- <el-button v-if="scope.row.delete" @click="submitRow(scope.row.id)" type="text">{{$t('lin_btn.delete')}}</el-button> -->
			<el-tooltip class="item" effect="dark" :content="$t('lin_btn.delete')" placement="top">
				<el-button type='text' v-if="scope.row.delete" @click="submitRow(scope.row.id)"><i class="fa fa-trash-o" style="color:#FF4949"></i></el-button>
			</el-tooltip>

      </template>
    </el-table-column>
    </el-table>
    <div v-if="totalRecords > 0" class="block text-center mt20 page_content" id="pagination">
      <el-pagination style='float:right;' @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10,50,100]"
        :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalRecords">
      </el-pagination>
    </div>
  </div>
</div>
</template>
<script>
import axios from 'axios'
import { baseurl,focusEvent,url,urlAssets } from '../../api/url'
import MechanismSelector from '@/components/global/mechanism_selector.vue'
export default{
  components: {
    MechanismSelector
  },
		name:'log',
		data(){
      var that = this
			return{
        mechanismData: {
          callback (value) {
            that.queryCondition.areaid = value
            that.statusChange()
          }
        },
        baseUrl:urlAssets.prefix,
				focusEvent: focusEvent,
				areaList1: [],
				value1: '',
				input1:'',
				queryCondition: {
		          'terminal_no': '',
		          'terminal_name': '',
		          'terminal_log_type': '',
		          'areaid': '',
		          'start_time': '',
		          'end_time': ''
		        },
		        loading: true,
		        currentPage: 1,
		        pageSize: 20,
		        totalRecords: 0,
		        tableData: []
			}

		},
		created: function(){ 
			if(this.$route.params.no){
				this.queryCondition.terminal_no = this.$route.params.no;
			}else{
				this.queryCondition.terminal_no = '';
			}
//			this.getAd1();
			this.getLog(1,this.queryCondition.terminal_no,'','','');
      let timers = setInterval(()=>{
        this.getLog(1,this.queryCondition.terminal_no,this.queryCondition.areaid,this.queryCondition.start_time,this.queryCondition.end_time)
      }, 300000 )
      localStorage.setItem("timers",timers);
		},
		methods:{
			catchLog () {

			},
      submitRow:function (id) {
        var params = {ids:id}
        this.$confirm(this.$t('lin_global.confirmDelete'), this.$t('lin_btn.tips'), {
          confirmButtonText: this.$t('lin_btn.confirm'),
          cancelButtonText: this.$t('lin_btn.cancel'),
          type: 'warning'
        }).then(() => {
          axios.post(`${baseurl}/terminalLog/delete.do`,params).then(res=>{
            if (res.data.status == 200) {
              this.$message.success(this.$t('lin_global.delete_success'))
              this.getLog(1,this.queryCondition.terminal_no,this.queryCondition.areaid,this.queryCondition.start_time,this.queryCondition.end_time)
            } else {
              this.$message.error(res.data.message)
            }
          })
        }).catch(() => {

        })
      },
      dataChange:function(value){
        this.queryCondition.start_time = value;
      },
      dataChange1:function(value){
        this.queryCondition.end_time = value;
      },
			getAd1:function(){
		    	var params = {page:1,rows:10000};
		    	axios.post(`${baseurl}/mechanism/list.do`,params).then(res=>{
		    		//console.log(res.data);
		    		var obj={
		    			'mechanismname':this.$t('lin_global.all_mechanism'),
		    			'mechanismid':''
		    		}
		    		this.areaList1 = res.data.data;

		    		this.areaList1.unshift(obj)
		    	})
		    },
		    reset(){
		    	this.queryCondition.terminal_no = '';
		    	this.queryCondition.areaid = '';
		    	this.queryCondition.start_time = '';
		    	this.queryCondition.end_time = '';
		    	this.getLog(1,'','','','');
		    },
		    statusChange(){
		    	this.getLog(1,this.queryCondition.terminal_no,this.queryCondition.areaid,this.queryCondition.start_time,this.queryCondition.end_time)
		    },
			handleIconClick:function(){
				this.getLog(1,this.queryCondition.terminal_no,this.queryCondition.areaid,this.queryCondition.start_time,this.queryCondition.end_time)
			},
			formatStatus:function(row,column){
		      return row.status == 0?this.$t('lin_global.ddsc'):row.status == 1?this.$t('lin_global.scz'):row.status == 2?this.$t('lin_global.sccg'):row.status == 3?this.$t('lin_global.scsb'):'';
		    },
		    search:function(){
		    	this.getLog(1,this.queryCondition.terminal_no,this.queryCondition.areaid,this.queryCondition.start_time,this.queryCondition.end_time);
		    },
			getLog:function(page,no,area,start,end){
				this.currentPage = page;

		  		var params = {page:page,rows:this.pageSize,mechId:area,terminalNo:no,beginTime:start,endTime:end};
		  		//console.log("打印氚餐");
		  		//console.log(params)
		        axios.post(`${baseurl}/terminalLog/getTerLogList.do`,params).then(res=>{
		            //console.log("打印应用列表");
		            //console.log(res.data);
		            this.tableData = res.data.data;
					this.totalRecords = res.data.total;
					this.loading = false;
        for(var i = 0;i<res.data.data.length;i++){
          if(res.data.data[i].status == 0){
            res.data.data[i]['delete'] = false;
            res.data.data[i]['down'] = false;
          }else if(res.data.data[i].status == 1){
            res.data.data[i]['delete'] = false;
            res.data.data[i]['down'] = false;
          }else if(res.data.data[i].status == 2){
            res.data.data[i]['delete'] = true;
            res.data.data[i]['down'] = true;
          }else if(res.data.data[i].status == 3){
            res.data.data[i]['delete'] = true;
            res.data.data[i]['down'] = false;
          }else{
            return false
          }
        }
		        })
			},
			handleSizeChange: function (val) {
		        this.pageSize = val
		        this.getLog(this.currentPage,this.queryCondition.terminal_no,this.queryCondition.areaid,this.queryCondition.start_time,this.queryCondition.end_time)
		        //console.log(`每页 ${val} 条`)
		    },
		    handleCurrentChange: function (val) {
		        this.currentPage = val
		        this.getLog(this.currentPage,this.queryCondition.terminal_no,this.queryCondition.areaid,this.queryCondition.start_time,this.queryCondition.end_time)
		        //console.log('当前页: ${val}')
      		}

		}
	}
</script>



// WEBPACK FOOTER //
// appLog.vue?67ad2b81